<template>
<div>
    <div :class="wrapper_class">
        <div :class="txta_class">
            <textarea 
            class="form-control input-field" 
            placeholder="Notes"
            v-model="newValue"
            @keyup="emitInput"
            @change="emitInput"
            :disabled="disabled"
            />
        </div>
        <div :class="list_class" class="position-relative notes_list_container" :id="list_container_id">
            <div v-show="loader" class="chart-loader"><div><i class="fad fa-circle-notch fa-spin fa-4x"></i></div></div>
            <div v-for="(item,key) in list" :key="key" class="note-wrap">
                <div class="note-author p-1 d-flex justify-content-between">
                  <div>{{ item.user_name }} - {{ dateFormat(item.created_at) }}:</div>
                  <div v-if="item.hash">
                    <btn variant="outline-primary" @click="removeNote(item)" title="Close"><i class="fal fa-times"></i></btn>
                  </div>
                </div>
                <div class="note-detail p-1 pl-2" v-html="item.html_text"></div>
            </div>
        </div>
    </div>
    
</div>    
</template>

<script>

import field from '@/mixins/field';
import formatting from '@/mixins/formatting'

export default {
    props: ['value','slug','hash','name','reload','direction'],
    mixins: [formatting],
    data() {
        return {
            loader: false,
            disabled: false,
            newValue: '',
            list: [],
            wrapper_class: 'd-flex',
            txta_class: 'w-50',
            list_class: 'w-50 pl-2'
        }
    },
    computed: {
        list_container_id() {
            return 'notes_list_container_' + this.name;
        }
    },
    watch: {
        value(val) {
            this.newValue = val;
        },
        reload(reload) {
            if (reload) {
                this.newValue = ''
                this.emitInput();
                this.load()
            }
        }
    },
    methods: {
        load() {
            this.loader = true;
            axios.post('/d/notes/list', 
                { 
                    form_hash: this.hash, 
                    field_name: this.name, 
                    slug: this.slug 
                })
                .then((res) => {
                   this.list = res.data
                   this.loader = false;
                   document.getElementById(this.list_container_id).scroll({top:0,behavior:'smooth'});
                })
        },
        emitInput() {
            this.$emit('input', this.newValue )
        },
        removeNote(note) {
          this.$utils.swalConfirm.fire({
            title: 'Delete this note?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'Confirm'
          }).then((result) => {
            if (result.value) {
              axios.post(`/d/notes/destroy_note`, {hash: note.hash})
                  .then((res) => {
                    const index = this.list.findIndex(n => n.hash === note.hash)
                    if (index !== -1) {
                      this.list.splice(index, 1)
                    }
                    this.$utils.c_notify(res.data.res, res.data.status);
                  })
            }
          })
        }
    },
    mounted() {
        this.load();
        if (this.direction == 'vertical') {
            this.wrapper_class  = 'd-flex flex-column',
            this.txta_class     = '',
            this.list_class     = 'mt-2'
        }
    }
}
</script>

<style scoped>
.input-field {
    height: 100px;
}
.note-detail {
    -webkit-transition: max-height 0.7s; 
    -moz-transition: max-height 0.7s; 
    -ms-transition: max-height 0.7s; 
    -o-transition: max-height 0.7s; 
    transition: max-height 0.7s;  
    overflow: hidden;
    max-height: 60px;
    overflow: hidden;
}
.note-wrap:hover .note-detail {
    max-height: 157px;
    overflow: auto;
}
.note-wrap {
    padding-left: 10px;
    border-left: 1px dashed #6f2971;
    position: relative;
}
.note-wrap::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 16px;
    border-radius: 16px;
    background-color: #6f2971;
    position: absolute;
    left: -4px;
    top: 10px;
}
.notes_list_container {
    padding-left: 5px;
}
</style>